var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ClipLoader } from 'react-spinners';
import { useLang } from '../hooks/use-lang';
import { useThemeEval } from '../hooks/use-theme-eval';
import { omit } from 'lodash';
var cls = classNames('option-menu-loading-message');
export var OptionMenuLoadingMessageDefaultProps = {
  colors: {
    text: 'mid',
    fill: 'subtle'
  },
  style: {
    gap: '8px',
    padding: '12px 12px'
  },
  spinnerSize: 20,
  text: "Please wait..."
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    font-size: ", "; \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    ", ";\n    font-size: ", "; \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])), theme.APPLY_COLORS, theme.FONT_SIZE(14))
});
var MessageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuLoadingMessage',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Message: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
export var OptionMenuLoadingMessage = React.forwardRef(function (props, ref) {
  var componentProps = useComponentProps(My.NAME, OptionMenuLoadingMessageDefaultProps, props);
  var className = componentProps.className,
    style = componentProps.style,
    children = componentProps.children,
    colors = componentProps.colors,
    text = componentProps.text,
    spinnerSize = componentProps.spinnerSize;
  var $ = useThemeEval();
  var t = useLang();
  var spinnerColor = colors.fill;
  return React.createElement(My.Container, {
    colors: omit(colors, 'fill'),
    style: style,
    className: cls.name(className)
  }, React.createElement(ClipLoader, {
    color: $(theme.COLOR(spinnerColor)),
    size: spinnerSize
  }), React.createElement(My.Message, null, t(text) || children));
});
/* @ts-ignore */
OptionMenuLoadingMessage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;